import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { IntlProvider, injectIntl } from 'react-intl-next';
import { ENGLISH_LOCALES, getMessagesForLocale } from '../../utils/i18n-util';
import english_messages from '../../i18n/en';
var MessagesIntlProvider = /*#__PURE__*/function (_React$Component) {
  function MessagesIntlProvider(props) {
    var _this;
    _classCallCheck(this, MessagesIntlProvider);
    _this = _callSuper(this, MessagesIntlProvider, [props]);
    _defineProperty(_this, "fetchLocale", function () {
      getMessagesForLocale(_this.props.intl.locale).then(function (messages) {
        return _this.setState({
          messages: messages
        });
      });
    });
    _this.state = {
      messages: ENGLISH_LOCALES.indexOf(props.intl.locale) !== -1 ? english_messages : undefined
    };
    _this.fetchLocale();
    return _this;
  }
  _inherits(MessagesIntlProvider, _React$Component);
  return _createClass(MessagesIntlProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(IntlProvider, {
        messages: this.state.messages,
        locale: this.props.intl.locale
      }, children);
    }
  }]);
}(React.Component);
var MessagesIntlProviderWithIntl = injectIntl(MessagesIntlProvider);
export default MessagesIntlProviderWithIntl;